import { QueryStatus, useQuery } from '@tanstack/react-query';

import { MapType } from '../CommonTypes';
import { fetchMaps } from './fetchMaps';
import useSite from './useSite';

export default function useMaps() {
  const [site] = useSite();
  const results = useQuery({
    queryKey: ['company', site.company, 'siteId', site.siteid, 'mapScenes'],
    queryFn: () => fetchMaps(site.company, site.siteid),
  });

  return [results?.data ?? [], results.status] as [MapType[], QueryStatus];
}
